module.exports = __webpack_public_path__ + "static/img/selective-focus-photograph-of-man-wearing-gray-suit-jacket-1138903.e9d516fa.jpg";